import PropTypes from 'prop-types';
import { contentType } from './constants';

export const bodySchemaPropType = PropTypes.shape({
  index: PropTypes.number.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  content: PropTypes.shape({
    type: PropTypes.oneOf[Object.values(contentType)],
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.object),
      PropTypes.object,
    ]),
  }).isRequired,
  shaded: PropTypes.bool,
  format: PropTypes.string,
  component: PropTypes.elementType,
}).isRequired;

export const bodySchemaArrayPropType =
  PropTypes.arrayOf(bodySchemaPropType).isRequired;

export const messagePropType = PropTypes.shape({
  message: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
});

export const cellDataPropType = PropTypes.shape({
  row: PropTypes.object,
  state: PropTypes.object,
}).isRequired;
